import {formatDate, buildColumn, XLARGE_CELL_WIDTH} from '@eitje/web_components'
import {FirmStatusCell, ArrayCell, AdminsCell} from '~/components/advanced_table/components/cells'
import {getFirmStatus, getEnvironmentStatuses} from '~/helpers'
import {prettyPrintArray} from '@eitje/utils'

export const columns = [
	{
		accessorKey: 'name',
		width: XLARGE_CELL_WIDTH,
	},
	{
		accessorKey: 'status',
		accessorFn: organisation => getFirmStatus(organisation.environments),
		cell: FirmStatusCell,
		infoIconMessageProps: {
			title: 'status',
			body: 'tooltips.status',
		},
	},
	{
		id: 'active_environments_names',
		accessorFn: organisation => {
			const {active, eitje} = getEnvironmentStatuses(organisation.environments)
			return [...active._map('naam'), ...eitje._map('naam')]
		},
		aggregates: false,
		cell: ArrayCell,
	},
	{
		id: 'admins',
		accessorFn: organisation => {
			// create normalized string to make grouping work
			const admins = organisation.environments.map(environment => environment.admins._map('id')).flat()
			return prettyPrintArray({array: admins, sort: true, joinWord: '&'})
		},
		cell: AdminsCell,
		aggregates: false,
		groupedTotalInChild: true,
	},
	{
		id: 'active_environments_count',
		accessorFn: organisation => {
			const {active, eitje} = getEnvironmentStatuses(organisation.environments)
			return active.length + eitje.length || 0
		},
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		id: 'inactive_environments_names',
		accessorFn: organisation => {
			const {inactive} = getEnvironmentStatuses(organisation.environments)
			return inactive._map('naam')
		},
		aggregates: false,
		cell: ArrayCell,
	},
	{
		id: 'inactive_environments_count',
		accessorFn: organisation => {
			const {inactive} = getEnvironmentStatuses(organisation.environments)
			return inactive.length
		},
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		accessorKey: 'created_at',
		format: formatDate,
	},
	{
		accessorKey: 'activeUsers',
		header: 'active_users',
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		accessorKey: 'first_billing_date',

		format: formatDate,
	},
	{accessorKey: 'id'},
].map(buildColumn)
